module.exports = __webpack_public_path__ + "media/src/images/mails/facebook-8a95955f9aeb61428885cedc3024e6f8.png";